import { render, staticRenderFns } from "./Beneficiary.vue?vue&type=template&id=46d42b0a&scoped=true"
import script from "./Beneficiary.vue?vue&type=script&lang=js"
export * from "./Beneficiary.vue?vue&type=script&lang=js"
import style0 from "./Beneficiary.vue?vue&type=style&index=0&id=46d42b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d42b0a",
  null
  
)

export default component.exports